import type { EngineId } from "../report/contracts";

export const engineTitleVi: Readonly<Record<EngineId, string>> = Object.freeze({
  bazi: "Bát Tự",
  ziwei: "Tử Vi",
  iching: "Kinh Dịch",
  feng_shui: "Phong Thủy",
  name_phone_wuxing: "Tên và số Ngũ Hành",
  pythagoras: "Thần số học",
});
